// @francesca- this page is the dynamic /category-gutschein page: content based on category type

export default {
  giftcards: {
    giftAnEvent: 'Giftcards for cooking classes',
    mostGifted: 'Most gifted classes',
    giftOptions: 'Gift ideas for cooking enthusiast',
    courses: 'Which course do you prefer?',
    categories: 'Pick from our favorite categories',
    header: {
      title: 'Gift a cooking course',
      description:
        'You want to make your loved ones happy? Then give away great cooking classes with our voucher.',
      button: 'BUY A GIFTCARD',
      image: '/giftcards/header.png',
      imageMobile: '/giftcards/header.png',
      titleTextColor: '#000000',
    },

    // @francesca can't find callToAction on page

    callToAction: {
      title: 'Book Events for Private Groups',
      subtitle:
        'Danish fontina feta cheese and wine. Jarlsberg emmental rubber cheese feta halloumi taleggio danish fontina taleggio. Pecorino stinking bishop taleggio cheddar goat jarlsberg dolcelatte the big cheese. Cut the cheese cream cheese ricotta.',
      buttonText: 'Join',
      inputPlaceholderText: "hello{'@'}gokonfetti.com",
      image: '/_nuxt3-static/homepage/CTA.webp',
      mobileImage: '/_nuxt3-static/homepage/CTA.webp',
    },

    heroes: {
      first: {
        title: 'Choose your giftcard value',
        subtitle: 'From 15€ to 150€ - choose your voucher value.',
        image: '/giftcards/subheader.png',
        mobileImage: '/giftcards/subheader.png',
        buttonText: 'BUY A GIFTCARD',
      },
      second: {
        title: 'Great gift ideas for cooking lovers',
        subtitle:
          'With our gift voucher you can give away over 500 cooking courses and cooking events. Thus, your gift will be memorable.',
        image: '/giftcards/cta.png',
        mobileImage: '/giftcards/cta.png',
        buttonText: 'LEARN MORE',
      },
    },
  },
}
